import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@fleet/auth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TravellerGuestJobGuard  {
  constructor(private authService: AuthService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    //clear any jwt

    this.authService.clearToken();
    return true;
  }
}
